import { render, staticRenderFns } from "./WixCallback.vue?vue&type=template&id=62b03a13&"
import script from "./WixCallback.vue?vue&type=script&lang=js&"
export * from "./WixCallback.vue?vue&type=script&lang=js&"
import style0 from "./WixCallback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports